import { find, isNumber } from 'lodash';

import { IntervalCommission } from 'types';

// Mirrors IntervalsService on the backend

const findIntervalCommission = (
  amount: number,
  intervalCommissions?: IntervalCommission[] | null,
): number | undefined =>
  find(
    intervalCommissions,
    (interval) => interval.min <= amount && amount < interval.max,
  )?.commission;

// the interval commission matching the amount wins, otherwise the default one
const calculateCommissionWithIntervals = (
  amount: number,
  defaultCommission: number,
  intervalCommissions?: IntervalCommission[] | null,
): number => {
  const intervalCommission = findIntervalCommission(
    amount,
    intervalCommissions,
  );
  return isNumber(intervalCommission) ? intervalCommission : defaultCommission;
};

const getProviderExpectedFeePercent = (
  amount: number,
  config:
    | { expectedFee?: number; intervalCommissions?: IntervalCommission[] }
    | undefined,
  intervalsEnabled: boolean,
): number =>
  calculateCommissionWithIntervals(
    amount,
    config?.expectedFee || 0,
    intervalsEnabled ? config?.intervalCommissions : undefined,
  );

export const intervalCommissionsUtils = {
  findIntervalCommission,
  calculateCommissionWithIntervals,
  getProviderExpectedFeePercent,
};
